import {inject, provideAppInitializer} from '@angular/core';
import {MerchantsService} from '../service/merchants.service';

export const MERCHANTS_PROVIDER = () => {
  return provideAppInitializer(() => {
    const initializerFn = ((merchantsService: MerchantsService) => {
      return () => merchantsService.init();
    })(inject(MerchantsService));
    return initializerFn();
  });
}
